<mat-toolbar class="header bg-white">
  <strong>Origin Batch Weigh</strong>
</mat-toolbar>
<div class="flex-grow-1 bg-white mt-1">
  <div class="container pt-3">
    <form [formGroup]="form" class="p-2" *ngIf="!loading else loadingTemplate">
      <div class="row">
        <div class="col-md-6">
          <ns-autocomplete [label]="'Origin'" [data]="origins" [formCtrl]="form.controls.origin"
                           [isLoading]="originsLoading" [isRequired]="true" [filter]="false">
          </ns-autocomplete>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label ngRequired>Recipient</mat-label>
            <input matInput formControlName="recipient"/>
            <mat-icon fontSet="fas" fontIcon="fa-info-circle" color="accent" matSuffix
                      matTooltip="You can enter multiple email addresses separed by comma or semi-colon"></mat-icon>
            <mat-error [control]="form.controls.recipient" ns-error></mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label ngRequired>Coal Density</mat-label>
            <input type="number" matInput formControlName="coalDensity" ngSpecialCharacter/>
            <mat-error [control]="form.controls.coalDensity" ns-error></mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <p class="mt-2"><strong>Source</strong> {{ source }}</p>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="row justify-content-end mt-5">
        <div class="col-md-3">
          <button mat-stroked-button color="warn" class="w-100" aria-label="Reset Form" (click)="form.reset()">Reset</button>
        </div>
        <div class="col-md-3">
          <button mat-flat-button color="accent" class="w-100" [disabled]="!form.valid" aria-label="Submit Report" (click)="submit()">Submit</button>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #loadingTemplate>
  <ns-skeleton [type]="skeleton"></ns-skeleton>
</ng-template>
